import { initializeApp, getApps } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

// Secrets were sometimes saved with stray quotes/commas — sanitize defensively.
const clean = (v) => (v || "").replace(/^[\s"'\\,]+|[\s"'\\,]+$/g, "");

const cfg = {
  apiKey: clean(process.env.REACT_APP_FIREBASE_API_KEY),
  authDomain: clean(process.env.REACT_APP_FIREBASE_AUTH_DOMAIN),
  projectId: clean(process.env.REACT_APP_FIREBASE_PROJECT_ID),
};

export const firebaseEnabled = Boolean(cfg.apiKey && cfg.authDomain && cfg.projectId);

let _auth = null;
export function getFirebaseAuth() {
  if (!firebaseEnabled) return null;
  const app = getApps()[0] || initializeApp(cfg);
  if (!_auth) {
    _auth = getAuth(app);
    _auth.useDeviceLanguage();
  }
  return _auth;
}

export { RecaptchaVerifier, signInWithPhoneNumber };
